import { render, staticRenderFns } from "./WikiApp.vue?vue&type=template&id=0d3a88d5&scoped=true"
import script from "./WikiApp.vue?vue&type=script&lang=js"
export * from "./WikiApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a88d5",
  null
  
)

export default component.exports